import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";

const isTracked = (path) => !path.startsWith("/admin");

export const AnalyticsTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isTracked(pathname)) trackEvent(pathname, "pageview");
  }, [pathname]);

  useEffect(() => {
    const iv = setInterval(() => {
      const p = window.location.pathname;
      if (!document.hidden && isTracked(p)) trackEvent(p, "heartbeat");
    }, 30000);
    return () => clearInterval(iv);
  }, []);

  return null;
};
